export const PR_V2_BASE_FILE_VIEWPORT_TOP_OFFSET = 72;
export const PR_V2_STICKY_TABS_LIST_SELECTOR = '[data-pr-v2-tabs-list="true"]';

export function getPrV2StickyTabsListOffset(referenceElement?: Element | null): number {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return 0;
  }

  const searchRoot = referenceElement?.closest('#scrollable-content') ?? document;
  const tabsList = searchRoot.querySelector(PR_V2_STICKY_TABS_LIST_SELECTOR);
  if (!(tabsList instanceof HTMLElement)) {
    return 0;
  }

  const position = window.getComputedStyle(tabsList).position;
  if (position !== 'sticky' && position !== 'fixed') {
    return 0;
  }

  const height = tabsList.getBoundingClientRect().height;
  return Number.isFinite(height) && height > 0 ? height : 0;
}

export function getPrV2FileViewportTopOffset(referenceElement?: Element | null): number {
  return PR_V2_BASE_FILE_VIEWPORT_TOP_OFFSET + getPrV2StickyTabsListOffset(referenceElement);
}
